import { createFileRoute } from "@tanstack/react-router";
import Plano from "@/pages/app/Plano";

export const Route = createFileRoute("/app/plano")({
  head: () => ({ meta: [{ title: "Meu plano | Braussie - Nutri" }] }),
  component: Plano,
});
